import React from "react";
import { FormattedMessage } from "react-intl";
import { Text } from "@domestika-dev/prudencio/dist/atoms/Typography/Typography";
import { GridItem } from "@domestika-dev/prudencio/dist/atoms/Layout";

export const LiveSessionScheduleTitle = () => (
  <GridItem gridRow={1} gridColumn="1 / span 8">
    <Text size="medium" fontWeight="medium" as="h1" textAlign="left">
      <FormattedMessage id="live_sessions.schedule_new.title" />
    </Text>
  </GridItem>
);

export default LiveSessionScheduleTitle;
